<template>
  <div class="h5-header-menu">
    <div class="h5-header-menu__left">
      <Icon
        class="h5-header-menu__icon"
        @click="showCategory"
        name="category-all-l"
      />
      <img
        v-if="!search"
        @click="goHome"
        src="@/assets/H5/home/logo.svg"
        alt=""
        width="120px"
      >
      <img
        v-else
        @click="goHome"
        class="h5-header-menu__icon"
        src="@/assets/H5/home/logo-icon.svg"
        alt=""
      >
    </div>
    <SearchInput
      v-if="search"
      :text="text"
      size="small"
    />
    <div class="h5-header-menu__right">
      <Icon
        v-if="!search"
        class="h5-header-menu__icon"
        name="time-history-l"
        @click="showHistory = true"
      />
      <img
        @click="toFavoritePage"
        class="h5-header-menu__icon"
        src="@/assets/images/favorite-outline.svg"
        alt=""
      >
      <div
        class="h5-header-item h5-header-cart"
        @click="toCartPage"
      >
        <Icon
          class="h5-header-menu__icon"
          :name="userInfo.uid ? cartStore.cartCount === 0 ? 'cart-f' : 'cart-icon-l' : 'cart-empty-l'"
        />
        <div
          v-if="cartStore.cartCount"
          class="cart-count"
        >
          {{ cartStore.cartCount > 99 ? '99+' : cartStore.cartCount }}
        </div>
      </div>
      <img
        v-if="!search"
        @click="toOrderPage"
        class="h5-header-menu__icon"
        src="@/assets/images/order.svg"
        alt=""
      >
      <Icon
        @click="signIn"
        class="h5-header-menu__icon"
        name="person-unlogin"
      />
    </div>
    <History v-model:show="showHistory" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Icon } from '@/components/Icon'
import { useStore } from 'vuex'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { useCartStore } from '@/pinia/cart'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/pinia/user'
import { useLoginModal } from '@/components/Login'
import History from './History.vue'
import SearchInput from './SearchInput.vue'

defineProps({
  text: {
    type: String,
    default: null
  },
  search: {
    type: Boolean,
    default: false
  }
})

const store = useStore()

const router = useRouter()

const cartStore = useCartStore()

const user = useUserStore()

const { open: openLoginModal } = useLoginModal()

const userInfo = computed(() => user.userInfo)

const showCategory = () => {
  store.commit('h5Module/setCategoryDialogVisible', true)
  buriedPointUtil({ eventId: 'MPWH401' })
}

const goHome = () => {
  window.location.href = '/'
}

const showHistory = ref(false)

const toCartPage = () => {
  buriedPointUtil({ eventId: 'MPC201' })
  router.push('/carts')
}

const toOrderPage = () => {
  router.push('/orders')
}

const toFavoritePage = () => {
  router.push({ name: 'favorites' })
}

const signIn = () => {
  if (userInfo.value.uid) {
    router.push('/account')
  } else {
    gaAnalytics('mp_sign_in_click', 'mp_sign_in_click')
    buriedPointUtil({ eventId: 'MPWH201' })
    buriedPointUtil({ eventId: 'MPLG501' })
    store.commit('setPassiveLogin', 0)
    openLoginModal()
  }
}

</script>

<style lang='less' scoped>
.h5-header-menu {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  &__left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__icon {
    color: white;
    width: 24px;
    height: 24px;
    font-size: 24px;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .h5-header-cart {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    .cart-count {
      position: absolute;
      top: -10px;
      left: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #FFD100;
      border: 1px solid #D25123;
      border-radius: 8px;
      height: 14px;
      padding: 0 6px;
      font-size: 10px;
      font-family: mon-500;
      color: #232323;
    }
  }
}
</style>
